import { get, post, put, Delete } from "../axios";

// 申请列表-列表
export const joinExamineList = (params) =>
  get("/web/join/examine/list", params);

// 申请列表-状态-编辑
export const joinExamineStateUpdate = (params) =>
  put("/web/join/examine/state/update", params);
